import { buildDomainSeoBundle } from "./agenticSeoUtils";

export const PHARMA_DOMAIN_INTRO = {
  title: "Pharma",
  content: "Agentic AI workflow automation for Pharma — across Pharmaceutical Manufacturing and Quality Operations. Use cases span batch record review and exception detection with governed workflow automation, human review, and audit evidence. Practical deployments for pharma manufacturers in India, UAE, KSA, UK, and USA.",
  seoDescription: "Pharma agentic AI use cases — batch record review exception detection pharmaceutical manufacturing. MES LIMS QMS DMS ERP batch record system integration. Agentic AI India UAE KSA UK USA.",
};

const slug = (label) => label.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

function withMeta(uc) { return { ...uc, groupId: slug(uc.subIndustry), seoTitle: uc.title, title: uc.shortTitle || uc.title }; }

const RAW = [
  {
    id: "batch-record-review-and-exception-detection",
    subIndustry: "Pharma Manufacturing",
    department: "QA / Compliance",
    businessProcess: "Batch record review and exception detection",
    regions: "India, UAE, KSA, UK, USA",
    shortTitle: "Batch record review and exception detection",
    title: "AI Batch Record Review for Pharma Manufacturing",
    seoKeywords: "pharma batch record automation, BMR review AI, GMP document AI, batch release automation",
    challenge: "QA teams manually review lengthy batch manufacturing records, logbooks, attachments, and deviations before batch release.",
    solution: "Document AI extracts batch record values, checks completeness, identifies missing signatures or deviations, and prepares review summaries for QA approval.",
    summary: "Pharma Manufacturing teams can improve batch record review and exception detection with agentic AI workflow automation that captures inputs, validates rules, routes exceptions, and updates business systems with human approval where needed — reducing manual effort and improving audit trails.",
    automationType: "Document AI + Workflow Automation + Agentic AI",
    buyerPersona: "QA Head, Compliance Head, Plant Head",
    systems: "QMS, MES, DMS, ERP, LIMS, SharePoint",
    agentsRequired: "Batch Review Agent, Deviation Check Agent, QA Approval Agent",
    inputData: "Batch records, BMR/BPR, logbooks, SOP rules, deviation forms, equipment records",
    outputActions: "Review summary, missing data list, deviation alert, QA approval workflow",
    keyBenefits: "Speeds Qa Review, Improves Data Consistency, Reduces Manual Document Checking, And Supports Audit Readiness.",
    roiTimeline: "6-12 months",
    implementationComplexity: "High",
    businessImpact: "High",
  },
];
export const PHARMA_USE_CASES = RAW.map(withMeta);
const GROUP_ORDER = ["Pharma Manufacturing"];
export const PHARMA_GROUPS = GROUP_ORDER.map((label) => ({ id: slug(label), label })).filter((g) => PHARMA_USE_CASES.some((uc) => uc.groupId === g.id));
const seo = buildDomainSeoBundle({ domainSlug: 'pharma-domain', domainIntro: PHARMA_DOMAIN_INTRO, useCases: PHARMA_USE_CASES });
export const PHARMA_USE_CASES_SEO = seo.useCasesSeo;
export const PHARMA_DOMAIN_FAQS = seo.domainFaqs;
export const PHARMA_ITEM_LIST_JSONLD = seo.itemListJsonLd;
export const PHARMA_FAQ_JSONLD = seo.faqJsonLd;
export const PHARMA_BREADCRUMB_JSONLD = seo.breadcrumbJsonLd;
export const PHARMA_WEBPAGE_JSONLD = seo.webPageJsonLd;

